/**
 * Values corresponds to KeyboardEvent.key values
 */
var KEYBOARD = {
  TAB: 'Tab',
  ESC: 'Escape',
  ENTER: 'Enter',
  ARROW_LEFT: 'ArrowLeft',
  ARROW_UP: 'ArrowUp',
  ARROW_RIGHT: 'ArrowRight',
  ARROW_DOWN: 'ArrowDown'
};

export { KEYBOARD };
